import { BaseNode } from './BaseNode';

export function LookupNode({
  data,
}: {
  data: { label: string; alias?: string; input?: string; table?: Record<string, unknown>; default?: string };
}) {
  const entryCount = data.table ? Object.keys(data.table).length : 0;

  return (
    <BaseNode
      type="lookup"
      label={data.label}
      alias={data.alias ? `${data.alias}.value` : undefined}
      lines={[
        { text: data.input, mono: true },
        { text: `${entryCount} mapping${entryCount === 1 ? '' : 's'}${data.default ? ' + default' : ''}` },
      ]}
    />
  );
}
